module.exports = __webpack_public_path__ + "static/media/trash.acdc89b3.svg";